import { Button, Row, Space, Table } from "antd";
import { ExcelSVG } from "assets";
import React, { useEffect, useMemo, useState } from "react";
import { rejectColumns } from "../config";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { setIdPhieuKham } from "redux/reducer/common";
import {
  setCheckedRow,
  setIdCustomerCare,
  setIdDatLich,
} from "redux/reducer/customerCare";
import { Notification } from "components/common";
import { consultantAndFragmentService } from "api";

const RejectPatient = ({
  data,
  setParams,
  params,
  total,
  loading,
  childTab,
  onExportEcel,
}) => {
  const onChangePagination = (page, pageSize) => {
    setParams({ ...params, page: page, limit: pageSize });
  };
  const dispatch = useAppDispatch();
  const checkedRow = useAppSelector((e) => e.customerCare.checkedRow);
  const getListReason = async () => {
    try {
      const res = await consultantAndFragmentService.getListReason();

      rejectColumns.find((e) => e.dataIndex === "lyDoTuChoi").render = (v) =>
        res.find((e) => e.id === v)?.tenLyDoTuChoi;
    } catch (error) {
      Notification("error", "Đã xảy ra lỗi khi lấy danh sách lý do từ chối");
    }
  };

  useEffect(() => {
    getListReason();
  }, []);
  const rowSelection = {
    selectedRowKeys: checkedRow,
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      dispatch(setIdCustomerCare(selectedRows[0].id));
      dispatch(setIdPhieuKham(selectedRows[0].idPhieuKham));
      dispatch(setIdDatLich(selectedRows[0].idPhieuTuVan));
      dispatch(setCheckedRow(selectedRowKeys));

      if (!selectedRows[0].idPhieuTuVan) {
        Notification(
          "info",
          "Bệnh nhân chưa có id phiếu tư vấn nên không thể hẹn lịch."
        );
      }
    },
  };
  useMemo(() => {
    dispatch(setCheckedRow([]));
    setParams({
      ...params,
      page: 1,
    });
  }, [childTab]);
  return (
    <div className="container">
      <Space direction="vertical" style={{ width: "100%" }}>
        <Row justify={"start"}>
          <Button
            icon={<ExcelSVG />}
            className="custom-btn"
            onClick={onExportEcel}
          >
            Xuất báo cáo
          </Button>
        </Row>
        <Table
          columns={rejectColumns}
          dataSource={data}
          loading={loading}
          pagination={{
            position: ["bottomRight"],
            showSizeChanger: true,
            total: total,
            current: params.page,
            onChange: onChangePagination,
          }}
          rowSelection={{
            type: "radio",
            ...rowSelection,
          }}
          scroll={{ x: 600 }}
          bordered
        />
      </Space>
    </div>
  );
};

export default RejectPatient;
